import { action } from 'typesafe-actions';
import { TomadoresTransportadoraTypes, ITomadoresTransportadora } from './types';

export const loadRequest = (parceiros: number[]) =>
  action(TomadoresTransportadoraTypes.LOAD_REQUEST, { parceiros });
export const loadSuccess = (data: ITomadoresTransportadora[]) =>
  action(TomadoresTransportadoraTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(TomadoresTransportadoraTypes.LOAD_FAILURE, {});
